export const ecaterinaCocetcova = {
    'meta': {
        'title': 'Psychiatra dzieci i młodzieży Ecaterina Cocetcova • COLLIGO',
        'description': 'Lekarz psychiatra z wieloletnim stażem. Doświadczenie zawodowe zdobywałam pracują w szpitalu oraz w poradniach zdrowia psychicznego.'
    },
    'url': {
        'address': '/torun/zespol/psychiatra-ecaterina-cocetcova/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/ecaterina-cocetcova.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psychiatra dzieci i młodzieży Ecaterina Cocetcova'
        }
    }
}